import { createSlice } from "@reduxjs/toolkit";
import { useAppSelector } from "../store";

export interface MarketsState {
  displayMarketAdvancedTools: boolean;
}

const initialState: MarketsState = {
  displayMarketAdvancedTools: true,
};

const MarketsToolsSlice = createSlice({
  name: "marketsTool",
  initialState,
  reducers: {
    toggleMarketAdvancedTools: (state) => {
      state.displayMarketAdvancedTools = !state.displayMarketAdvancedTools;
    },
  },
});

export default MarketsToolsSlice;

export const useMarketsToolsState = () => useAppSelector((state) => state.marketsTool);

export const { toggleMarketAdvancedTools } = MarketsToolsSlice.actions;
